/* AKKA HOME — Studio Letter PDP picker (staged)
   One persistent custom picker layer, built ONCE outside Dawn's re-render zone.
   Dawn's native picker stays in the DOM (clip-hidden) and keeps driving price,
   gallery and cart; our buttons just .click() its radios.

   GENERIC BY DESIGN. It reads whatever options a product actually has and gives
   each one a role:
     colour  → painted dots            (Colour)
     type    → image strip             (Type / Variety / Bloom / Scene / Panel / Motif)
     seg     → text buttons            (everything else: Corner Style, Number of
                                        Tiles, Style, and any option added later)
   The seg fallback matters: the native picker is hidden, so an unrendered option
   would be unselectable. Never let an option fall through unrendered.

   Exception — decals: akka-motif-step2 replaces the native picker in 'self' mode,
   so we stand down entirely (see standDown()).
*/
(function () {
  var productData = null;
  var layer = null;
  var observer = null;
  var pending = null;
  var imageNote = null;
  var groups = [];   // [{cls, role, label, noun}] in option order

  /* Captions hang off the VALUE, so they work whatever the option is called. */
  var VALUE_CAPTIONS = {
    'Delft': 'Delft corners join into neighbouring tiles',
    'Blank': 'the motif stands alone',
    'Single Tile': 'one tile — live with it on the wall before you commit',
    '10 Tiles': 'a pack of ten — covers about 0.93 m²',
    'As is': 'the tile exactly as it was painted',
    'With coaster feet': 'finished with felt feet, to live on a table'
  };
  var COLOUR_NAMES = { 'Dutch': 'Dutch Blue', 'Potters': 'Potters Green', 'New England': 'New England Red' };
  /* Legacy colour names still live on the Studio Seconds range. Give them the
     right swatch, but keep their own name on screen — don't silently rename. */
  var COLOUR_HEX = {
    'Dutch': '#1D3766', 'Potters': '#183A22', 'New England': '#6E1219',
    'Bayswater': '#1D3766', 'Borgo': '#677BA3', 'Granger': '#6E1219'
  };

  var TYPE_WORDS = [
    { k: 'scene', noun: 'scenes', label: 'Choose your scene' },
    { k: 'panel', noun: 'panels', label: 'Choose your panel' },
    { k: 'motif', noun: 'motifs', label: 'Choose your motif' },
    { k: 'bloom', noun: 'blooms', label: 'Choose your bloom' },
    { k: 'variety', noun: 'designs', label: 'Choose your design' },
    { k: 'design', noun: 'designs', label: 'Choose your design' },
    { k: 'type', noun: 'designs', label: 'Choose your design' }
  ];

  function motifBlock() { return document.getElementById('AkkaMotifs'); }
  function standDown() {
    var m = motifBlock();
    return !!m && m.getAttribute('data-mode') === 'self';
  }
  /* Where a motif picker adds extra line items, a price×qty ATC label would
     understate the basket — leave Dawn's own label alone. */
  function atcLabelAllowed() { return !motifBlock(); }

  function optionNames() {
    if (!productData || !productData.options) return [];
    return productData.options.map(function (o) {
      return (typeof o === 'string') ? o : (o && o.name) || '';
    });
  }

  function classifyFieldsets() {
    var names = optionNames();
    var handle = (productData && productData.handle) || location.pathname.split('/').pop();
    var fsList = Array.prototype.slice.call(document.querySelectorAll('.product-form__input'));
    var next = [];
    fsList.forEach(function (fs, i) {
      var legend = fs.querySelector('legend') || fs.querySelector('.form__label');
      if (!legend) return;
      var cls = 'sl-opt-' + next.length;
      fs.classList.add(cls);
      var raw = names[i] || legend.textContent.replace(/\s+/g, ' ').trim();
      var name = raw.toLowerCase();

      var role = 'seg', label = raw, noun = null;
      if (name.indexOf('colour') > -1 || name.indexOf('color') > -1) {
        role = 'colour'; label = 'Colour';
      } else if (name.indexOf('corner') > -1) {
        /* "Corner Style" — a seg, but keep the friendlier label. */
        role = 'seg'; label = 'Corner style';
      } else if (name.indexOf('number of tiles') > -1) {
        role = 'seg'; label = 'How many';
      } else {
        for (var t = 0; t < TYPE_WORDS.length; t++) {
          if (name.indexOf(TYPE_WORDS[t].k) > -1) {
            role = 'type';
            noun = TYPE_WORDS[t].noun;
            label = TYPE_WORDS[t].label;
            if (handle === 'flower' && TYPE_WORDS[t].k === 'type') { noun = 'blooms'; label = 'Choose your bloom'; }
            break;
          }
        }
      }
      next.push({ cls: '.' + cls, role: role, label: label, noun: noun });
    });
    groups = next;
  }

  function pickerEl() {
    return document.querySelector('variant-selects') || document.querySelector('variant-radios');
  }
  function nativeInputs(cls) {
    var fs = document.querySelector(cls);
    return fs ? Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]')) : [];
  }
  function nativeValues(cls) {
    var seen = {};
    return nativeInputs(cls).map(function (i) { return i.value; }).filter(function (v) {
      if (seen[v]) return false; seen[v] = 1; return true;
    });
  }
  function nativeSelected(cls) {
    var c = nativeInputs(cls).filter(function (i) { return i.checked; })[0];
    return c ? c.value : null;
  }
  function nativeSelect(cls, value) {
    var inp = nativeInputs(cls).filter(function (i) { return i.value === value; })[0];
    if (inp && !inp.checked) inp.click();
  }
  function colourGroup() {
    for (var i = 0; i < groups.length; i++) if (groups[i].role === 'colour') return groups[i];
    return null;
  }

  function findVariant(mustHave) {
    if (!productData || !productData.variants) return null;
    var loose = null;
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      if (!v.featured_image) continue;
      if (v.options.indexOf(mustHave[0]) === -1) continue;
      if (!loose) loose = v;
      var ok = true;
      for (var j = 1; j < mustHave.length; j++) {
        if (mustHave[j] && v.options.indexOf(mustHave[j]) === -1) { ok = false; break; }
      }
      if (ok) return v;
    }
    return loose;
  }
  function thumbFor(value, extra) {
    var v = findVariant([value].concat(extra || []));
    if (!v || !v.featured_image) return null;
    var src = v.featured_image.src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }

  function buildLayer() {
    if (layer && document.body.contains(layer)) return;
    var native = pickerEl();
    if (!native || !groups.length) return;
    layer = el('div', '');
    layer.id = 'sl-picker';
    layer.dataset.built = String(Date.now());

    groups.forEach(function (g, gi) {
      var values = nativeValues(g.cls);
      if (!values.length) return;

      if (g.role === 'colour') {
        var gc = el('div', 'sl-p-group' + (values.length < 2 ? ' sl-p-fixed' : ''));
        gc.appendChild(el('div', 'sl-p-labelrow',
          '<span class="sl-p-label">' + g.label + '</span><span class="sl-p-sel" data-sel="' + gi + '"></span>'));
        var dots = el('div', 'sl-p-dots');
        values.forEach(function (v) {
          var b = el('button', 'sl-p-dot');
          b.type = 'button';
          b.dataset.value = v;
          b.dataset.g = gi;
          b.innerHTML = '<i style="background:' + (COLOUR_HEX[v] || '#999') + '"></i><span>' + v + '</span>';
          b.addEventListener('click', function () { nativeSelect(g.cls, v); syncLayer(); });
          dots.appendChild(b);
        });
        gc.appendChild(dots);
        layer.appendChild(gc);
        var sample = document.getElementById('sl-sample-line');
        if (sample) { sample.style.display = ''; gc.appendChild(sample); }
        return;
      }

      if (g.role === 'type') {
        var gt = el('div', 'sl-p-group');
        gt.appendChild(el('div', 'sl-p-labelrow',
          '<span class="sl-p-label">' + g.label + '</span>' +
          '<span class="sl-p-count">' + values.length + ' ' + (g.noun || 'designs') + '</span>' +
          '<span class="sl-p-sel" data-sel="' + gi + '"></span>'));
        var wrap = el('div', 'sl-strip-wrap');
        var strip = el('div', 'sl-strip');
        values.forEach(function (v) {
          var b = el('button', 'sl-strip-b');
          b.type = 'button';
          b.dataset.value = v;
          b.dataset.g = gi;
          b.title = v;
          b.setAttribute('aria-label', v);
          b.innerHTML = '<img alt="' + v + '" loading="lazy">';
          b.addEventListener('click', function () { nativeSelect(g.cls, v); syncLayer(); });
          strip.appendChild(b);
        });
        wrap.appendChild(strip);
        gt.appendChild(wrap);
        layer.appendChild(gt);
        return;
      }

      /* seg — the catch-all. Text buttons, so no option can go unrendered. */
      var gs = el('div', 'sl-p-group');
      gs.appendChild(el('div', 'sl-p-labelrow', '<span class="sl-p-label">' + g.label + '</span>'));
      var seg = el('div', 'sl-corners');
      values.forEach(function (v) {
        var b = el('button', 'sl-corner-b');
        b.type = 'button';
        b.dataset.value = v;
        b.dataset.g = gi;
        b.textContent = v;
        b.addEventListener('click', function () { nativeSelect(g.cls, v); syncLayer(); });
        seg.appendChild(b);
      });
      gs.appendChild(seg);
      gs.appendChild(el('p', 'sl-seg-cap', ''));
      gs.querySelector('.sl-seg-cap').dataset.g = gi;
      layer.appendChild(gs);
    });

    native.insertAdjacentElement('beforebegin', layer);
  }

  function syncLayer() {
    if (!layer) return;
    var selected = groups.map(function (g) { return nativeSelected(g.cls); });
    var colour = null;
    for (var i = 0; i < groups.length; i++) if (groups[i].role === 'colour') colour = selected[i];

    layer.querySelectorAll('.sl-p-sel').forEach(function (s) {
      var gi = parseInt(s.dataset.sel, 10);
      var v = selected[gi];
      var pretty = (groups[gi] && groups[gi].role === 'colour') ? (COLOUR_NAMES[v] || v) : v;
      s.textContent = v ? '— ' + pretty : '';
    });

    layer.querySelectorAll('.sl-p-dot').forEach(function (b) {
      b.classList.toggle('on', b.dataset.value === selected[parseInt(b.dataset.g, 10)]);
    });

    layer.querySelectorAll('.sl-strip-b').forEach(function (b) {
      var gi = parseInt(b.dataset.g, 10);
      var on = b.dataset.value === selected[gi];
      b.classList.toggle('on', on);
      var img = b.querySelector('img');
      var src = thumbFor(b.dataset.value, [colour]);
      if (src && img.getAttribute('src') !== src) img.src = src;
      if (on) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });

    layer.querySelectorAll('.sl-corner-b').forEach(function (b) {
      b.classList.toggle('on', b.dataset.value === selected[parseInt(b.dataset.g, 10)]);
    });
    layer.querySelectorAll('.sl-seg-cap').forEach(function (cap) {
      var v = selected[parseInt(cap.dataset.g, 10)];
      cap.textContent = (v && VALUE_CAPTIONS[v]) || '';
    });

    updateCaption();
    updateAtcLabel();
  }

  /* Mockup ATC reads "Add to Cart — $52.00" (price × qty). Parse the
     rendered, market-aware price so US visitors see their currency. */
  function updateAtcLabel() {
    if (!atcLabelAllowed()) return;
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;
    var span = btn.querySelector('span');
    if (!span || btn.disabled) return;
    if (/sold out|unavailable/i.test(span.textContent)) return;
    var priceEl = document.querySelector('.price__sale .price-item--sale') || document.querySelector('.price__regular .price-item--regular');
    if (!priceEl) return;
    var m = priceEl.textContent.replace(/,/g, '').match(/([^\d]*)(\d+(?:\.\d+)?)/);
    if (!m) return;
    var qtyEl = document.querySelector('.quantity__input');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var total = parseFloat(m[2]) * qty;
    var label = 'Add to Cart — ' + m[1].trim() + total.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (span.textContent !== label) span.textContent = label;
  }

  /* Per-product "Images shown in colour …" note lives in the product
     description (rendered in the first accordion). Lift it out and show it
     under the gallery instead — nothing shown if a product has no note. */
  function extractImageNote() {
    var re = /images?\s+shown\s+in\s+colou?rs?\b[^.]*(\.|$)/i;
    document.querySelectorAll('.sl-acc-body p').forEach(function (p) {
      var t = p.textContent || '';
      var m = t.match(re);
      if (!m) return;
      if (!imageNote) imageNote = m[0].trim();
      var rest = t.replace(m[0], '').trim();
      if (rest.length < 2) { if (p.parentNode) p.parentNode.removeChild(p); }
      else p.textContent = rest;
    });
  }

  function updateCaption() {
    var cap = document.querySelector('.sl-gallery-caption');
    if (!imageNote) { if (cap && cap.parentNode) cap.parentNode.removeChild(cap); return; }
    var gal = document.querySelector('media-gallery') || document.querySelector('.product__media-wrapper');
    if (!gal) return;
    if (!cap) {
      cap = document.createElement('div');
      cap.className = 'sl-gallery-caption';
      cap.style.cssText = "font-family:'Fraunces',serif;font-style:italic;font-size:13px;color:#66604F;margin-top:12px;";
      gal.appendChild(cap);
    }
    if (cap.textContent !== imageNote) cap.textContent = imageNote;
  }

  function ensureQtyRow() {
    var helper = document.getElementById('sl-qty-helper');
    if (!helper) return;
    var qty = document.querySelector('.product-form__quantity') || document.querySelector('.product-form__input--quantity');
    if (!qty) return;
    if (qty.parentNode && qty.parentNode.classList && qty.parentNode.classList.contains('sl-qty-row')) {
      if (helper.parentNode !== qty.parentNode) qty.parentNode.appendChild(helper);
      return;
    }
    var row = document.createElement('div');
    row.className = 'sl-qty-row';
    qty.parentNode.insertBefore(row, qty);
    row.appendChild(qty);
    row.appendChild(helper);
  }

  function hideNative() {
    var native = pickerEl();
    if (native && layer) native.classList.add('sl-native-picker');
  }

  function applyAll() {
    if (observer) observer.disconnect();
    try {
      if (!standDown()) {
        classifyFieldsets();
        buildLayer();
        hideNative();
      }
      ensureQtyRow();
      extractImageNote();
      if (!standDown()) syncLayer();
      else updateCaption();
    } finally {
      startObserver();
    }
  }
  function scheduleApply() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(applyAll, 120);
  }
  function startObserver() {
    var root = document.querySelector('product-info') || document.querySelector('.product__info-wrapper') || document.querySelector('main') || document.body;
    if (!observer) observer = new MutationObserver(scheduleApply);
    observer.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    fetch(window.location.pathname.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { productData = d; applyAll(); })
      .catch(function () { applyAll(); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__input')) scheduleApply();
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
